import { defaultHttpClient } from '../../httpClient';
import type { GoodsModelInfoResponse } from './types';

/**
 * - 상품 모델 정보 조회 API
 * - GET /api/v2/goods/{sno}/fashion_model/
 */
export const getGoodsModelInfo = async (
  goodsSno: number,
): Promise<GoodsModelInfoResponse> => {
  try {
    const result = await defaultHttpClient.request<GoodsModelInfoResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/fashion_model/`,
    });

    if (typeof result.data === 'string' && result.data === '') {
      return null;
    }

    return result.data;
  } catch {
    return null;
  }
};
